import React from "react";
import { CardElement } from "@stripe/react-stripe-js";
import translations from "../../utils/translations";
import { getBrokerInformation } from "../../store/broker";
import { useDispatch, useSelector } from "react-redux";

const CARD_ELEMENT_OPTIONS = {
  hidePostalCode: true,
  style: {
    base: {
      color: "#303238",
      fontSize: "16px",
      fontFamily: "sans-serif",
      fontSmoothing: "antialiased",
      "::placeholder": {
        color: "#CFD7DF",
      },
    },
    invalid: {
      color: "#e5424d",
      ":focus": {
        color: "#303238",
      },
    },
  },
};

function CardSection() {
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;
  const translationsBrokerAdmin =
    translations[languagepreference].brokerageAdmin;
  return (
    <label
      style={{
        fontFamily: "GibsonSemiBd",
        fontSize: "1.4vw",
        color: "rgb(63, 68, 90)",
        marginTop: "15px",
      }}
    >
      {translationsBrokerAdmin.cardDetails}

      <div
        style={{
          marginInline: languagepreference == "en" ? "-173px" : "-135",
        }}
      >
        <CardElement options={CARD_ELEMENT_OPTIONS} />
      </div>
    </label>
  );
}

export default CardSection;
